export class ExistsNoneUnconfirmedConverter {
	public toView(value): string {
		if (!value) {
			value = '';
		}
		const v = value.toString().trim().toUpperCase();

		switch (v) {
			case 'Y':
				return 'Exists';
			case 'N':
			case '':
				return 'None';
			case 'U':
				return 'Unconfirmed';
			default:
				return '';
		}
	}
}
